import React from 'react';

import { Flex } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { Cross, MeshLogo } from 'assets/assetsV1/iconComponents';

import { Button } from 'uiToolkitV1/Button';
import { TextLabel } from 'uiToolkitV1/Typography';

const BotNotificationModal = ({ setIsBotNotificationBarOpen }) => (
  <Flex
    sx={{
      height: '48px',
      marginLeft: checkNewNavEnabled() ? '-16px' : 0,
      marginRight: checkNewNavEnabled() ? '-16px' : 0,
      background: '#FFFFFF',
    }}
    display="flex"
  >
    <GradientBorder>
      <Flex justifyContent="center" alignItems="center">
        <MeshLogo boxSize="20px" mr="15px" ml="10px" />
        <TextLabel>
          A meeting bot will be joining you in this meeting to provide a summary along with any actionable from that
          meeting. The summary is confidential and accessible only to the participants of the call.
        </TextLabel>
      </Flex>

      <Button
        sx={{
          marginTop: '4px',
          marginLeft: 'auto',
          svg: {
            color: '#333333 !important',
          },
        }}
        onClick={() => setIsBotNotificationBarOpen(false)}
        variant="tertiary"
        EndIcon={Cross}
      />
    </GradientBorder>
  </Flex>
);

export default BotNotificationModal;

const GradientBorder = styled.div`
  display: flex;
  position: relative;
  border: none;
  width: 100%;
  padding: 0px 10px;

  &::before,
  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    height: 1px;
  }

  &::before {
    top: 0;
    background: linear-gradient(
      to left,
      rgba(0, 142, 240, 0.8),
      rgba(236, 59, 100, 0.8),
      rgba(255, 194, 0, 0.8),
      rgba(92, 196, 97, 0.8)
    );
  }

  &::after {
    bottom: 0;
    background: linear-gradient(
      to left,
      rgba(0, 142, 240, 0.8),
      rgba(236, 59, 100, 0.8),
      rgba(255, 194, 0, 0.8),
      rgba(92, 196, 97, 0.8)
    );
  }
`;
